import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { packagingTypeIcons } from '@/common/constants'

import * as Styles from './styles'

const PackagingSelector = ({ packaging, value, onChange }) => {
  const { t } = useTranslation()

  const menuItems = packaging.map(item => {
    const Icon = packagingTypeIcons[item.type]
    return {
      label: (
        <Styles.MenuItemContent>
          {Icon && <Icon size={20} />}
          {item.name}
        </Styles.MenuItemContent>
      ),
      value: item.id,
    }
  })

  return (
    <ComboBox
      label={t('Embalaje')}
      menuItems={menuItems}
      value={value}
      handleChange={e => onChange(e.target.value)}
      fullWidth
    />
  )
}

export default PackagingSelector
